import React from 'react';
import AdminAccounts from '../containers/AdminAccounts.jsx';

export default (props) => (
  <AdminAccounts {...props} />
);
